export default __webpack_public_path__ + "static/media/azOktatasEsMunkaVilaga.148d7a98.png";